// extracted by css-extract-rspack-plugin
export default {"label":"d83yaqCxE0YQifQN","value":"RhH0MxzAGuEoEO8L","caption":"R20IUeSxUqQMF5yi"};